import { render } from "./Add.vue?vue&type=template&id=41704d39"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/services/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41704d39"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41704d39', __exports__)) {
    console.log('reload')
    api.reload('41704d39', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=41704d39", () => {
    console.log('re-render')
    api.rerender('41704d39', render)
  })

}


export default __exports__